<template>
  <div>
    <template>
      <div class="card mb-1">
        <div class="card-header d-block border-bottom">
          <div class="text-center">
            <h4 class="font-weight-bolder text-uppercase text-primary">
              Daftar BMD Inventarisasi KIB B
              <br /> Tahun {{ parentFilter.tahun }}
            </h4>
          </div>
        </div>
        <div class="card-body pt-1">
          <template v-if="(parentFilter.tahun && parentFilter.kolok > 0)">
            <b-row class="mb-1">
              <b-col cols="12">
                <div class="d-flex flex-md-row flex-column justify-content-between overflow-auto">
                  <div class="mr-2 d-flex flex-column flex-wrap" style="width: max-content; gap: 5px;">
                    <div>
                      <span class="font-weight-bolder text-uppercase">Nama PD/UKPD/UPB</span>
                    </div>
                    <div>
                      <span class="font-size-lg">{{ formDatas.nalok || '-' }}</span>
                    </div>
                    <div class="">
                      <span class="font-weight-bolder text-uppercase">Jumlah Register</span>
                    </div>
                    <div>
                      <span class="font-size-lg">{{ `${new Intl.NumberFormat('id-ID').format(totalRecords)}` }}</span>
                    </div>
                  </div>

                  <div class="text-center border rounded border-light bg-light-primary"
                    style="min-width: 200px; width: 200px; height: 70px; position: relative;">
                    <div
                      style="position: absolute; top: 20px; left: 50%; transform: translate(-50%, -50%); width: max-content;">
                      <span class="font-weight-bolder text-uppercase">Status</span>
                    </div>
                    <div class="overflow-auto" style="margin: 35px 5px 10px 5px;">
                      <b-badge variant="light-primary">
                        {{ formDatas.nama_status }}
                      </b-badge>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <div v-if="!isLoadingTable">
              <div v-if="(!statusSkTim || !hasRuangan)" class="row p-1">
                <div class="col-12 border border-1 p-1 rounded text-center bg-light-warning">
                  <div class="text-warning font-weight-bold text-uppercase">Peringatan !</div>
                  <span>Proses pengajuan daftar BMD Inventarisasi KIB B tidak dapat dilakukan sebelum mengunggah dokumen
                    SK TIM dan mendefinisikan
                    minimal 1 Ruangan</span>
                </div>
              </div>
            </div>
            <hr />
          </template>
          <div class="row my-1">
            <b-input-group>
              <b-input-group-prepend>
                <v-select id="searchOpt" class="search-filter-option-select" v-model="formFilterDataBmd.key_cari"
                  label="text" :options="searchOptions" />
              </b-input-group-prepend>
              <b-form-input id="Kata" v-model="formFilterDataBmd.cari"
                placeholder="Pencarian data BMD, pilih kata kunci pencarian lalu tekan enter" type="text"
                class="d-inline-block" @keyup.enter="handleSearch" />
              <b-input-group-append v-if="(parentFilter.tahun && parentFilter.kolok > 0) && (hasRuangan && statusSkTim)">
                <div class=" d-flex justify-content-end">
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" size="sm"
                    style="border-top-left-radius: 0;border-bottom-left-radius: 0;" @click="cetakDaftarBmd">
                    <feather-icon icon="PrinterIcon" class="mr-50" />
                    <span class="align-middle">Cetak Daftar BMD</span>
                  </b-button>
                </div>
              </b-input-group-append>
            </b-input-group>
          </div>
          <div class="row my-25">
            <!-- <div class="col-12 col-md-6">
              <b-form-group>
                <b-form-input id="Kata" v-model="formFilterDataBmd.cari"
                  placeholder="Pencarian data BMD, ketik kata kunci pencarian lalu tekan enter" type="text"
                  class="d-inline-block" @keyup.enter="handleSearch" />
              </b-form-group>
            </div> -->
            <!-- <div v-if="(parentFilter.tahun && parentFilter.kolok > 0) && (hasRuangan && statusSkTim)"
              class="col-12 col-md-6">
              <div class=" d-flex justify-content-end">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" size="md"
                  @click="cetakDaftarBmd">
                  <feather-icon icon="PrinterIcon" class="mr-50" />
                  <span class="align-middle">Cetak Daftar BMD</span>
                </b-button>
              </div>
            </div> -->
          </div>
          <b-row>
            <b-col cols="12">
              <vue-good-table theme="polar-bear" :columns="columns" :rows="rows" :pagination-options="{
                enabled: true, perPage: row, jumpFirstOrLast: true,
              }" :total-rows="totalRecords" :is-loading.sync="isLoadingTable" mode="remote"
                @on-sort-change="onSortChange">
                <template slot="table-row" slot-scope="props">
                  <div v-if="props.column.field === 'total_harga'" class="text-right">
                    <span>
                      {{ `${new Intl.NumberFormat('id-ID', {
                        maximumFractionDigits: 2,
                      }).format(props.formattedRow[props.column.field])}` }}
                    </span>
                  </div>
                  <div v-else-if="props.column.field === 'tgl_oleh'">
                    <span>{{ parserValue('dateOnly', props.row['tgl_oleh']) || '-' }}</span>
                  </div>
                  <div v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </div>
                </template>
                <template slot="pagination-bottom">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                      <span class="text-nowrap"> Menampilkan 1 hingga </span>
                      <b-form-select v-model="row" :options="['10','25','50']" class="mx-1"
                        @input="handlePageChange" />
                      <span class="text-nowrap">
                        dari {{ totalRecords }} entri
                      </span>
                    </div>
                    <div>
                      <b-pagination :value="1" :total-rows="totalRecords" :per-page="row" first-number last-number
                        align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                        @change="handleChangePage">
                        <template #prev-text>
                          <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                          <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                      </b-pagination>
                    </div>
                  </div>
                </template>
              </vue-good-table>
            </b-col>
          </b-row>
          <hr>
          <div class="row mb-2"
            v-if="(hasRuangan && statusSkTim) && parentFilter.kolok > 0 && formDatas.status == 'register-unvalidated' && $can('Sumbit-Pengajuan', 'b-daftar-bmd')">
            <div class="col-12 d-flex justify-content-center">
              <div class="text-center bg-light-danger p-2 rounded">
                <div class="font-weight-bolder mb-2">Pengajuan validasi daftar register BMD kepada P3B</div>
                <div class="text-center">
                  <b-button v-if="!loadingSubmitPengajuanValidasi" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="danger" size="md" @click="openPengajuanValidasiDialog">
                    <feather-icon icon="SendIcon" class="mr-50" />
                    <span class="align-middle">Ajukan Validasi</span>
                  </b-button>
                  <b-button v-else variant="danger" disabled>
                    <b-spinner small />
                    Loading...
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2"
            v-if="parentFilter.kolok > 0 && ['register-ajukan-pb'].includes(formDatas.status) && $can('Validasi-P3B', 'b-daftar-bmd')">
            <div class="col-12 d-flex justify-content-center">
              <div class="text-center bg-light-primary p-2 rounded">
                <div class="font-weight-bolder mb-2">Validasi daftar register BMD oleh P3B</div>
                <div class="text-center">
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="md"
                    @click="openp3bValidasiDialog">
                    <feather-icon icon="CheckCircleIcon" class="mr-50" />
                    <span class="align-middle">Validasi P3B</span>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2"
            v-if="parentFilter.kolok > 0 && ['register-validated-p3b'].includes(formDatas.status) && $can('Validasi-Kepala', 'b-daftar-bmd')">
            <div class="col-12 d-flex justify-content-center">
              <div class="text-center bg-light-primary p-2 rounded">
                <div class="font-weight-bolder mb-2">Validasi daftar register BMD oleh Kepala</div>
                <div class="text-center">
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="md"
                    @click="openKepalaValidasiDialog">
                    <feather-icon icon="CheckCircleIcon" class="mr-50" />
                    <span class="align-middle">Validasi Kepala</span>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Validasi -->
      <template v-if="(parentFilter.tahun && parentFilter.kolok > 0) && formDatas.urutan >= 1">
        <div v-for="(item, i) in formDatas.workflow" :key="i" class="card mb-1">
          <div class="card-header border-bottom">
            <h4 v-if="item.status_type == 'register-ajukan-pb'" class="font-weight-bold text-uppercase">
              Pengajuan
            </h4>
            <h4 v-else-if="item.status_type == 'register-validated-p3b'" class="font-weight-bold text-uppercase">
              Validasi P3B
            </h4>
            <h4 v-else-if="item.status_type == 'register-validated-ka'" class="font-weight-bold text-uppercase">
              Validasi Kepala PD/UKPD/UPB
            </h4>
          </div>
          <div class="card-body pt-1">
            <div class="row mb-2">
              <div class="col-12 col-md-6 col-lg-6" style="padding: 0 5px 0 5px;">
                <div class="p-1">
                  <div>
                    <span class="font-weight-bolder"> {{ item.status_type == 'register-ajukan-pb' ?
                      'Diajukan' : 'Divalidasi' }} Oleh</span>
                  </div>
                  <div>
                    <span>{{ item.action_by || '-' }}</span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6" style="padding: 0 5px 0 5px;">
                <div class="p-1">
                  <div>
                    <span class="font-weight-bolder">{{ item.status_type == 'register-ajukan-pb' ?
                      'Diajukan' : 'Divalidasi' }} Pada</span>
                  </div>
                  <div>
                    <span>{{ parserValue('dateTime', item.action_at) || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <b-modal id="modal-pengajuan-validasi" ref="pengajuanValidasiModalRef" centered title="Pengajuan Validasi P3B"
        button-size="md" ok-title="Kirim" cancel-title="Batal" cancel-variant="outline-secondary"
        @ok="confirmKirimPengajuanValidasi">
        <b-card-text>
          Data Daftar Register Inventarisasi KIB B akan diajukan divalidasi kepada P3B. Lanjutkan ?
        </b-card-text>
      </b-modal>
      <b-modal id="modal-p3b-validasi" ref="p3bValidasiModalRef" centered title="Validasi P3B" button-size="md"
        ok-title="Setujui" cancel-title="Batal" cancel-variant="outline-secondary" @ok="confirmP3bValidasiDialog">
        <b-card-text>
          Data Daftar Register Inventarisasi KIB B akan divalidasi oleh P3B. Lanjutkan ?
        </b-card-text>
      </b-modal>
      <b-modal id="modal-kepala-validasi" ref="kepalaValidasiModalRef" centered title="Validasi Kepala" button-size="md"
        ok-title="Setujui" cancel-title="Batal" cancel-variant="outline-secondary" @ok="confirmKepalaValidasiDialog">
        <b-card-text>
          Data Daftar Register Inventarisasi KIB B akan divalidasi oleh Kepala. Lanjutkan ?
        </b-card-text>
      </b-modal>
    </template>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { showNotifikasi } from '@/libs/helper';
import { VueGoodTable } from "vue-good-table";
import { parserValue } from '@/libs/helper'
import daftarBmd from "@/composables/b/daftarBmd";
import searchOpt from "@/composables/b/searchOpt";
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    VueGoodTable,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    fd: { type: Object, required: true },
    parentFilter: { type: Object, required: true },
  },
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g
    const formDatas = ref({})

    // variable untuk table
    const statusSkTim = ref(false);
    const start = ref(0)
    const rows = ref([])
    const row = ref(10)
    const totalRecords = ref(0)
    const sortColumn = ref('')
    const order = ref('')
    const isLoadingTable = ref(false)
    const formFilterDataBmd = ref({
      kolok: [props.parentFilter.kolok],
      limit: row.value,
      start: start.value,
      cari: null,
      key_cari: { text: '-- Pilih Key --', value: '' },
    })
    const getDataBmd = () => {
      isLoadingTable.value = true
      const params = {
        kolok: (props.parentFilter.kolok) ? props.parentFilter.kolok : 'semua',
        limit: formFilterDataBmd.value.limit,
        start: formFilterDataBmd.value.start,
        cari: formFilterDataBmd.value.cari,
        key_cari: (formFilterDataBmd.value.key_cari) ? formFilterDataBmd.value.key_cari.value : '',
      }
      daftarBmd.getDataBmd(g, params).then(resp => {
        if (resp.success) {
          rows.value = resp.rows
          totalRecords.value = resp.totalRows
          statusSkTim.value = resp.statusSkTim;
        } else {
          rows.value = []
          totalRecords.value = 0
        }
        isLoadingTable.value = false
      }).catch(err => {
        console.log(err)
        isLoadingTable.value = false
      })
    }

    const handleSearch = searching => {
      formFilterDataBmd.value.start = 0
      getDataBmd()
    }

    const handlePageChange = length => {
      formFilterDataBmd.value.limit = length
      getDataBmd()
    }

    const handleChangePage = page => {
      formFilterDataBmd.value.start = (page - 1) * row.value
      getDataBmd()
    }

    const onSortChange = params => {
      console.log(params)
      sortColumn.value = params[0].field
      order.value = params[0].type
      getDataBmd()
    }
    /* On Mounted */
    const hasRuangan = ref(false);
    const getData = () => {
      const params = props.parentFilter
      if ((params.tahun && params.kolok > 0)) {
        daftarBmd.getDetail(g, params).then(res => {
          hasRuangan.value = res.memilikiRuangLokasi;
          formDatas.value = { ...formDatas.value, ...res.data }
        }).catch(err => {
          hasRuangan.value = false;
          console.log(err)
        })
      } else {
        hasRuangan.value = false;
      }
      getDataBmd()
    }
    getData()
    /* ------------------------------- */
    /* Pengajuan Validasi */
    const loadingSubmitPengajuanValidasi = ref(false)
    const formDatapengajuanValidasi = ref({
      username: g.$cookies.get('username'),
    })
    const pengajuanValidasiModalRef = ref(null)
    const openPengajuanValidasiDialog = () => {
      pengajuanValidasiModalRef.value.show()
    }
    const confirmKirimPengajuanValidasi = () => {
      loadingSubmitPengajuanValidasi.value = true
      const fd = { ...formDatapengajuanValidasi.value }
      fd.register_b_id = formDatas.value.register_b_id
      daftarBmd.submitPengajuan(g, fd).then(resp => {
        if (resp.success) {
          getData()
          showNotifikasi(g, 'success', 'Success', resp.message)
          context.emit('changeStateEvent', 'detail')
        } else {
          showNotifikasi(g, 'danger', 'Error', resp.message)
        }
        loadingSubmitPengajuanValidasi.value = false
      }).catch(err => {
        console.log(err)
        loadingSubmitPengajuanValidasi.value = false
      })
    }

    /* Validasi */
    const formDatasP3BValidasi = ref({
      username: g.$cookies.get('username'),
    })
    const p3bValidasiModalRef = ref(null)
    const openp3bValidasiDialog = () => {
      p3bValidasiModalRef.value.show()
    }
    const confirmP3bValidasiDialog = () => {
      const fd = { ...formDatasP3BValidasi.value }
      fd.register_b_id = formDatas.value.register_b_id
      daftarBmd.validasiP3b(g, fd).then(resp => {
        if (resp.success) {
          getData()
          showNotifikasi(g, 'success', 'Success', resp.message)
          context.emit('changeStateEvent', 'detail')
        } else {
          showNotifikasi(g, 'danger', 'Error', resp.message)
        }
      }).catch(err => {
        console.log(err)
      })
    }

    const formDatasKepalaValidasi = ref({
      username: g.$cookies.get('username'),
    })
    const kepalaValidasiModalRef = ref(null)
    const openKepalaValidasiDialog = () => {
      kepalaValidasiModalRef.value.show()
    }
    const confirmKepalaValidasiDialog = () => {
      const fd = { ...formDatasP3BValidasi.value }
      fd.register_b_id = formDatas.value.register_b_id
      daftarBmd.validasiKepala(g, fd).then(resp => {
        if (resp.success) {
          getData()
          showNotifikasi(g, 'success', 'Success', resp.message)
          context.emit('changeStateEvent', 'detail')
        } else {
          showNotifikasi(g, 'danger', 'Error', resp.message)
        }
      }).catch(err => {
        console.log(err)
      })
    }

    /* Download Upload Dokumen SK Tim */
    const loadingCetak = ref(false)
    const cetakDaftarBmd = () => {
      const linkToOpen = process.env.VUE_APP_URL_BACKEND + process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna-b/bmd/daftar-bmd?kolok=' + props.parentFilter.kolok; // Replace with your specific link
      window.open(linkToOpen, '_blank');
    }

    /* Search Option */
    const searchOptions = ref([]);
    const getSearchOptions = () => {
      searchOpt.getSearchOpt(g, { list: 'daftar_bmd' }).then(resp => {
        if (resp.success) {
          searchOptions.value = resp.rows
        } else {
        }
        searchOptions.value.unshift({ text: '-- Pilih Key --', value: '' })

      }).catch(err => {
        console.log(err)
      })
    };
    getSearchOptions();
    return {
      hasRuangan,
      parserValue,
      getData,
      formDatas,

      /* Table */
      formFilterDataBmd,
      handleSearch,
      handlePageChange,
      handleChangePage,
      onSortChange,
      rows,
      start,
      row,
      totalRecords,
      sortColumn,
      order,
      isLoadingTable,

      statusSkTim,

      /* Pengjuan Validasi */
      loadingSubmitPengajuanValidasi,
      formDatapengajuanValidasi,
      pengajuanValidasiModalRef,
      openPengajuanValidasiDialog,
      confirmKirimPengajuanValidasi,

      openp3bValidasiDialog,
      p3bValidasiModalRef,
      formDatasP3BValidasi,
      confirmP3bValidasiDialog,

      openKepalaValidasiDialog,
      kepalaValidasiModalRef,
      formDatasKepalaValidasi,
      confirmKepalaValidasiDialog,

      loadingCetak,
      cetakDaftarBmd,

      searchOptions
    }
  },
  data() {
    return {
      imgUrl: require('@/assets/images/pages/register-v2-dark.svg'),
      required,
      columns: [
        {
          label: 'Guid ID',
          field: 'guid_aset',
          width: '350px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Kolok',
          field: 'kolok',
          width: '150px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nalok',
          field: 'nalok',
          width: '400px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Kode Barang',
          field: 'kobar_108',
          width: '150px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nomor Register',
          field: 'noreg_108',
          width: '175px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nama Barang',
          field: 'nabar_108',
          width: '250px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Tanggal Perolehan',
          field: 'tgl_oleh',
          width: '190px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Total Harga',
          field: 'total_harga',
          width: '190px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Bahan',
          field: 'nama_bahan',
          width: '190px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Merk',
          field: 'merk',
          width: '190px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Tipe',
          field: 'tipe',
          width: '350px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nomor Chasis',
          field: 'nochasis',
          width: '190px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nomor Mesin',
          field: 'nomesin',
          width: '190px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nomor Polisi',
          field: 'nopol',
          width: '190px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nomor BPKB',
          field: 'nobpkb',
          width: '190px',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
      ],
    }
  },
  watch: {
    parentFilter: {
      handler(newVal, oldVal) {
        this.getData()
      },
      deep: true,
    },
  },
  methods: {
    changeStateEvent(event) {
      this.$emit('changeStateEvent', event)
    },
  },
}
</script>
<style>
.search-filter-option-select {
  min-width: 150px;

  ::v-deep .vs__dropdown-toggle {
    border-radius: 0;
  }

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
